
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/ulcer-management-country",
      function () {
        return require("private-next-pages/[lang]/ulcer-management-country/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/ulcer-management-country"])
      });
    }
  